import CalculatorForm from "@/components/CalculatorForm";
import ContactRail from "@/components/ContactRail";

export default function Calcolatore() {
  return (
    <>
      <section className="bg-white py-24 md:py-32 px-6 border-b border-[var(--ink)]/10" data-testid="calcolatore-page">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center mb-12">
            <div className="lg:col-span-7">
              <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-2">
                Simulatore Immediato
              </span>
              <h1 className="font-display text-[clamp(32px,3.8vw,52px)] font-bold leading-tight">
                Calcola la stima del tuo immobile
              </h1>
              <p className="font-mono-lbl text-xs text-[var(--ink)]/60 mt-4 max-w-md">
                Parametri ponderati su stato conservativo, riscaldamento e spese condominiali.
                Stima tarata sui valori reali di Modena e provincia.
              </p>
            </div>
            <figure className="lg:col-span-5 relative rounded-lg overflow-hidden border-2 border-[var(--gold)] shadow-lg">
              <img
                src="/valutatore-team.jpg"
                alt="Il team di Ascari Home Consulting in agenzia a Modena"
                className="w-full h-full object-cover"
                data-testid="calcolatore-team-photo"
              />
              <figcaption className="absolute bottom-3 left-3 font-mono-lbl text-[10px] uppercase text-[var(--ink)] bg-white/95 px-2 py-1 rounded">
                Il team Ascari · Agenzia Immobiliare
              </figcaption>
            </figure>
          </div>

          <CalculatorForm />

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 font-mono-lbl text-xs">
            <div className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded p-4">
              <span className="text-[var(--gold-deep)] font-bold block mb-1 uppercase">01 · Parametri</span>
              <span className="text-[var(--ink)]/70">Mq, zona, piano, stato, riscaldamento e spese condominiali.</span>
            </div>
            <div className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded p-4">
              <span className="text-[var(--gold-deep)] font-bold block mb-1 uppercase">02 · Stima</span>
              <span className="text-[var(--ink)]/70">Fascia di valore immediata calcolata su criteri tecnici.</span>
            </div>
            <div className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded p-4">
              <span className="text-[var(--gold-deep)] font-bold block mb-1 uppercase">03 · Sopralluogo</span>
              <span className="text-[var(--ink)]/70">Perizia tecnica gratuita per la valutazione reale di vendita.</span>
            </div>
          </div>
        </div>
      </section>

      <ContactRail />
    </>
  );
}
